// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MXY0UkP_TqnlZBkfRN4n{position:fixed;top:0;left:0;width:100vw;height:100vh;display:grid;place-items:center;z-index:100000;background-color:var(--color-spec_modal_bg)}.FkUj7gAhlG8S6YIgyWUO{height:80%;width:80%;overflow:hidden;border-radius:16px;max-width:initial}.FkUj7gAhlG8S6YIgyWUO .am6sQ80qo3FUeF_173yt{display:flex;flex-direction:column;justify-content:space-between;height:100%}.FkUj7gAhlG8S6YIgyWUO .am6sQ80qo3FUeF_173yt div>div{display:flex;align-content:center;justify-content:center;align-items:center}.FkUj7gAhlG8S6YIgyWUO .am6sQ80qo3FUeF_173yt div>div img{height:auto;max-height:100%}.FkUj7gAhlG8S6YIgyWUO .am6sQ80qo3FUeF_173yt video{width:100%;height:100%;display:flex;align-items:center;justify-content:center}.FkUj7gAhlG8S6YIgyWUO .Cw_1mFkaC3dDuVB2MrQ3{position:absolute;right:8px;top:8px}.FkUj7gAhlG8S6YIgyWUO .AktZ8P_A9fLhe3KczMcr{width:100%;padding-top:28px;height:100%}.FkUj7gAhlG8S6YIgyWUO .AktZ8P_A9fLhe3KczMcr img{height:100%;max-width:100%;display:flex;margin:0 auto}.FkUj7gAhlG8S6YIgyWUO .AktZ8P_A9fLhe3KczMcr mjx-container{height:100%;margin-top:25vh !important}.FkUj7gAhlG8S6YIgyWUO figcaption{font-weight:400;font-size:14px;line-height:20px;color:#8496b9;text-align:left;position:relative;padding-top:20px;margin-top:24px}.FkUj7gAhlG8S6YIgyWUO figcaption:before{position:absolute;top:0;content:"";width:100%;height:1px;background-color:#8496b9}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"modalContainer": `MXY0UkP_TqnlZBkfRN4n`,
	"modal": `FkUj7gAhlG8S6YIgyWUO`,
	"previewContainer": `am6sQ80qo3FUeF_173yt`,
	"closeIcon": `Cw_1mFkaC3dDuVB2MrQ3`,
	"content": `AktZ8P_A9fLhe3KczMcr`
};
export default ___CSS_LOADER_EXPORT___;
